import React from 'react';
import {
  Modal, Pressable, SafeAreaView, StyleSheet, View,
} from 'react-native';
import { Video } from 'expo-av';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import PropTypes from 'prop-types';

function VideoModal(props) {
  const { video, visible, closeModal } = props;

  return (
    <Modal
      visible={visible}
      onDismiss={closeModal}
      onRequestClose={closeModal}
      transparent
      animationType="slide"
    >
      <SafeAreaView style={styles.safeAreaView}>
        <Pressable style={styles.container} onPress={closeModal}>
          <Pressable style={styles.content}>
            <MaterialCommunityIcons
              name="close-circle"
              onPress={closeModal}
              style={styles.closeButton}
            />
            <View style={styles.videoContainer}>
              <Video
                style={styles.video}
                source={{
                  uri: video,
                }}
                useNativeControls
                resizeMode="contain"
              />
            </View>
          </Pressable>
        </Pressable>
      </SafeAreaView>

    </Modal>
  );
}

VideoModal.defaultProps = {
  video: '',
  visible: false,
  closeModal: () => {},
};

VideoModal.propTypes = {
  video: PropTypes.string,
  visible: PropTypes.bool,
  closeModal: PropTypes.func,
};

const styles = StyleSheet.create({
  safeAreaView: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    alignSelf: 'flex-end',
    color: 'white',
    fontSize: 24,
    marginTop: 5,
    marginRight: 5,
  },
  content: {
    width: '80%',
    height: '50%',
    backgroundColor: 'black',
    shadowColor: 'white',
    shadowOpacity: 0.5,
    shadowRadius: 10,
    borderRadius: 15,
  },
  videoContainer: {
    flex: 1,
  },
  video: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    resizeMode: 'contain',
    borderRadius: 15,
  },
});

export default VideoModal;
